import { DatePipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";

@Component({
  selector: "e-tracking",
  templateUrl: "./e-tracking-container.component.html",
  styleUrls: ["./e-tracking-container.component.css"],
})
export class ETrackingContainer implements OnInit {

  localStorageKey = 'selectedTimezone';
  selectedTimezone: string;
  validPrefixes: Array<string>;
  statusMapLastEvent: object;
  statusMap: object;
  validFlightCarrier: Array<string>;
  statusMessages: object;

  constructor(private datePipe: DatePipe) {

    this.selectedTimezone = 'UTC';
    this.validPrefixes = ['729', '202', '133'];
    this.statusMapLastEvent = {
      "Booked": "BKD",
      "Received From Shipper": "RCS",
      "Manifested": "MAN",
      "Departed": "DEP",
      "Arrived": "ARR",
      "Received From Flight": "RCF",
      "Documents Delivered": "AWD",
      "Delivered": "DLV",
    }
    this.statusMap = {
      "Booked": "BKD",
      "Received": "RCT",
      "Received From Shipper": "RCS",
      "Manifested": "MAN",
      "Departed": "DEP",
      "Vuelo": "Vuelo",
      "Arrived": "ARR",
      "Received From Flight": "RCF",
      "Documents Delivered": "AWD",
      "Delivered": "DLV",
    }
    this.statusMessages = {
      "Booked": "The shipment is booked.",
      "Received From Shipper": "Cargo and documents are received and accepted.",
      "Manifested": "The shipment is manifested.",
      "Departed": "Cargo and documents departed at ",
      "Arrived": "Cargo and documents arrived at ",
      "Received From Flight": "Cargo has arrived in the cargo bay at ",
      "Documents Delivered": "Hand over of documents.",
      "Delivered": "Cargo and documents delivered.",
    }
    this.validFlightCarrier = ["QT", "AV", "6R", "G3"];
  }

  ngOnInit(): void {
    const storedTimezone = localStorage.getItem(this.localStorageKey);
    if (storedTimezone) {
      this.selectedTimezone = storedTimezone;
    }
  }

  getSelectedTimezone(): string {
    const storedTimezone = localStorage.getItem(this.localStorageKey);
    if (storedTimezone) {
      this.selectedTimezone = storedTimezone;
      return storedTimezone;
    }
    return this.selectedTimezone;
  }

  updateSelectedTimezone(newTimezone: string) {
    this.selectedTimezone = newTimezone;
    localStorage.setItem(this.localStorageKey, newTimezone);
  }

  getvalidPrefixes() {
    return this.validPrefixes;
  }

  getStatusMapLastEvent() {
    return this.statusMapLastEvent;
  }

  getStatusMap() {
    return this.statusMap;
  }

  getStatusMessages() {
    return this.statusMessages;
  }

  getLastEvent(shipmentHistory) {
    const orderedStates = Object.keys(this.statusMapLastEvent);
    const lastState = orderedStates
      .filter(status => shipmentHistory.some(event => event.status === status))
      .pop();

    return this.statusMapLastEvent[lastState];
  }

  getLastStatusMessage(shipmentHistory) {
    const orderedStates = Object.keys(this.statusMessages);
    const lastState = orderedStates
      .filter(status => shipmentHistory.some(event => event.status === status))
      .pop();

    let message = this.statusMessages[lastState] + shipmentHistory[shipmentHistory.length - 1].airport_code;

    return message;
  }

  getFlightCarrier() {
    return this.validFlightCarrier;
  }

  formatDateForDisplay(dateTime: string): string {
    const timezone = this.selectedTimezone || 'UTC';

    const date = new Date(dateTime);
    let formattedDate = '';

    if (isNaN(date.getTime())) {
      return '';
    }

    if (timezone === 'Local') {
      const options: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
      };
      formattedDate = date.toLocaleString('en-US', options).replace(',', ' /');
    } else if (timezone === 'UTC') {
      const options: Intl.DateTimeFormatOptions & { timeZone?: string } = {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
        timeZone: 'UTC'
      };
      formattedDate = date.toLocaleString('en-US', options).replace(',', ' /');
    }

    return formattedDate;
  }
}
